import { Suspense, lazy, useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Banners from '../components/Banners';
import Footer from '../components/Footer';
import './PagesCommon.css';

const { Content } = Layout;
const Feature = lazy(() => import('../components/Feature'));
const LoginPopup = lazy(() => import('../components/LoginPopup'));
const landingQuickLinks = [
  { to: '/dictation', label: '听抄训练' },
  { to: '/shadowing', label: '影子跟读' },
  { to: '/help', label: '帮助中心' },
  { to: '/about', label: '关于我们' },
  { to: '/contact', label: '联系我们' }
];

const LandingPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginVisible, setLoginVisible] = useState(false);
  const [shouldRenderFeature, setShouldRenderFeature] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);
  }, [location.key]);

  useEffect(() => {
    let timeoutId;

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(() => {
        setShouldRenderFeature(true);
      }, { timeout: 1200 });

      return () => window.cancelIdleCallback(idleId);
    }

    timeoutId = window.setTimeout(() => {
      setShouldRenderFeature(true);
    }, 200);

    return () => window.clearTimeout(timeoutId);
  }, []);

  const showLogin = () => setLoginVisible(true);
  const hideLogin = () => setLoginVisible(false);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    hideLogin();
    const prevPath = new URLSearchParams(location.search).get('from');
    if (prevPath) {
      navigate(prevPath);
      return;
    }
    navigate('/editor');
  };

  return (
    <Layout className="page-layout">
      <Nav
        current="product"
        handleClick={() => {}}
        isLoggedIn={isLoggedIn}
        onLoginSuccess={handleLoginSuccess}
        hideMenu
      />
      <div className="nav-placeholder"></div>
      <Content className="page-content">
        <Banners
          isLoggedIn={isLoggedIn}
          showLogin={showLogin}
        />
        {shouldRenderFeature && (
          <Suspense fallback={<div style={{ minHeight: 640 }} aria-hidden="true" />}>
            <Feature />
          </Suspense>
        )}
      </Content>
      <Footer quickLinks={landingQuickLinks} />
      {loginVisible && (
        <Suspense fallback={null}>
          <LoginPopup
            visible={loginVisible}
            onClose={hideLogin}
            onLoginSuccess={handleLoginSuccess}
          />
        </Suspense>
      )}
    </Layout>
  );
};

export default LandingPage;
